var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoCaracGrupo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 58,
    viewBox: "0 0 88 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 58,
    rx: 16,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8009 26.772C68.879 25.519 67.4575 24.8555 65.6879 24.8555C60.8368 24.8555 57.1235 29.7836 53.5585 34.7053C52.3755 32.821 51.1377 30.956 49.7485 29.4615C47.7435 27.3066 45.6967 26.263 43.4952 26.263C41.2936 26.263 39.25 27.3099 37.2419 29.4615C36.2039 30.5759 35.2531 31.8965 34.3473 33.2784L35.5399 34.9211C37.835 31.3425 40.2944 28.157 43.4984 28.157C47.1247 28.157 49.8 32.2444 52.3626 36.3608L53.4424 38.0937C55.8309 41.8881 58.2065 45.1864 61.5717 45.1864C63.9054 45.1864 66.339 43.3697 68.2569 40.2035C69.9492 37.4077 71 33.9193 71 31.1042C70.9968 29.3069 70.5939 27.8478 69.8009 26.772ZM66.6324 39.2243C65.0916 41.7721 63.1963 43.2924 61.5685 43.2924C59.0317 43.2924 56.8817 40.0424 54.6415 36.4414C54.6802 36.3866 54.7189 36.3351 54.7575 36.2803C58.1485 31.5938 61.6555 26.7462 65.6879 26.7462C67.9507 26.7462 69.0982 28.2085 69.0982 31.0977C69.1014 33.594 68.157 36.7055 66.6324 39.2243ZM51.3569 37.7137C48.8169 41.0796 46.2028 43.9495 43.4952 43.9495C40.8327 43.9495 38.2604 41.173 35.7624 37.8811C35.3852 37.3819 35.0081 36.873 34.631 36.3576L33.4319 34.7053C29.8701 29.7836 26.1568 24.8555 21.3056 24.8555C19.536 24.8555 18.1145 25.519 17.1926 26.772C16.3997 27.8478 16 29.3069 16 31.1042C16 33.9226 17.0508 37.4109 18.7398 40.2035C20.6545 43.3697 23.0914 45.1864 25.4251 45.1864C28.7902 45.1864 31.1659 41.8881 33.5544 38.0937C36.6423 42.2842 39.6916 45.8467 43.4952 45.8467C46.899 45.8467 49.6969 42.9929 52.4625 39.395L52.2337 39.0536L51.3569 37.7137ZM25.4251 43.2924C23.7973 43.2924 21.902 41.7721 20.3612 39.2243C18.8398 36.7087 17.8921 33.5972 17.8921 31.1042C17.8921 28.215 19.0396 26.7526 21.3024 26.7526C25.338 26.7526 28.8418 31.6002 32.2328 36.2868C32.2715 36.3415 32.3101 36.3931 32.3488 36.4478C30.1118 40.0424 27.9618 43.2924 25.4251 43.2924Z",
    fill: "url(#paint0_linear_845_998)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4982 12C40.6681 12 38.3634 14.303 38.3634 17.131C38.3634 19.9591 40.6681 22.2621 43.4982 22.2621C46.3283 22.2621 48.633 19.9591 48.633 17.131C48.633 14.303 46.3283 12 43.4982 12ZM43.4982 20.3681C41.7124 20.3681 40.2587 18.9155 40.2587 17.131C40.2587 15.3466 41.7124 13.8939 43.4982 13.8939C45.2839 13.8939 46.7376 15.3466 46.7376 17.131C46.7376 18.9155 45.2839 20.3681 43.4982 20.3681Z",
    fill: "url(#paint1_linear_845_998)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8618 12C63.0317 12 60.727 14.303 60.727 17.131C60.727 19.9591 63.0317 22.2621 65.8618 22.2621C68.6919 22.2621 70.9966 19.9591 70.9966 17.131C70.9966 14.303 68.6919 12 65.8618 12ZM65.8618 20.3681C64.0761 20.3681 62.6223 18.9155 62.6223 17.131C62.6223 15.3466 64.0761 13.8939 65.8618 13.8939C67.6475 13.8939 69.1012 15.3466 69.1012 17.131C69.1012 18.9155 67.6475 20.3681 65.8618 20.3681Z",
    fill: "url(#paint2_linear_845_998)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1348 12C18.3047 12 16 14.303 16 17.131C16 19.9591 18.3015 22.2621 21.1348 22.2621C23.9681 22.2621 26.2696 19.9591 26.2696 17.131C26.2696 14.303 23.9649 12 21.1348 12ZM21.1348 20.3681C19.3491 20.3681 17.8953 18.9155 17.8953 17.131C17.8953 15.3466 19.3491 13.8939 21.1348 13.8939C22.9205 13.8939 24.3743 15.3466 24.3743 17.131C24.3743 18.9155 22.9205 20.3681 21.1348 20.3681Z",
    fill: "url(#paint3_linear_845_998)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8009 26.772C68.879 25.519 67.4575 24.8555 65.6879 24.8555C60.8368 24.8555 57.1235 29.7836 53.5585 34.7053C52.3755 32.821 51.1377 30.956 49.7485 29.4615C47.7435 27.3066 45.6967 26.263 43.4952 26.263C41.2936 26.263 39.25 27.3099 37.2419 29.4615C36.2039 30.5759 35.2531 31.8965 34.3473 33.2784L35.5399 34.9211C37.835 31.3425 40.2944 28.157 43.4984 28.157C47.1247 28.157 49.8 32.2444 52.3626 36.3608L53.4424 38.0937C55.8309 41.8881 58.2065 45.1864 61.5717 45.1864C63.9054 45.1864 66.339 43.3697 68.2569 40.2035C69.9492 37.4077 71 33.9193 71 31.1042C70.9968 29.3069 70.5939 27.8478 69.8009 26.772ZM66.6324 39.2243C65.0916 41.7721 63.1963 43.2924 61.5685 43.2924C59.0317 43.2924 56.8817 40.0424 54.6415 36.4414C54.6802 36.3866 54.7189 36.3351 54.7575 36.2803C58.1485 31.5938 61.6555 26.7462 65.6879 26.7462C67.9507 26.7462 69.0982 28.2085 69.0982 31.0977C69.1014 33.594 68.157 36.7055 66.6324 39.2243ZM51.3569 37.7137C48.8169 41.0796 46.2028 43.9495 43.4952 43.9495C40.8327 43.9495 38.2604 41.173 35.7624 37.8811C35.3852 37.3819 35.0081 36.873 34.631 36.3576L33.4319 34.7053C29.8701 29.7836 26.1568 24.8555 21.3056 24.8555C19.536 24.8555 18.1145 25.519 17.1926 26.772C16.3997 27.8478 16 29.3069 16 31.1042C16 33.9226 17.0508 37.4109 18.7398 40.2035C20.6545 43.3697 23.0914 45.1864 25.4251 45.1864C28.7902 45.1864 31.1659 41.8881 33.5544 38.0937C36.6423 42.2842 39.6916 45.8467 43.4952 45.8467C46.899 45.8467 49.6969 42.9929 52.4625 39.395L52.2337 39.0536L51.3569 37.7137ZM25.4251 43.2924C23.7973 43.2924 21.902 41.7721 20.3612 39.2243C18.8398 36.7087 17.8921 33.5972 17.8921 31.1042C17.8921 28.215 19.0396 26.7526 21.3024 26.7526C25.338 26.7526 28.8418 31.6002 32.2328 36.2868C32.2715 36.3415 32.3101 36.3931 32.3488 36.4478C30.1118 40.0424 27.9618 43.2924 25.4251 43.2924Z",
    fill: "url(#paint4_linear_845_998)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4982 12C40.6681 12 38.3634 14.303 38.3634 17.131C38.3634 19.9591 40.6681 22.2621 43.4982 22.2621C46.3283 22.2621 48.633 19.9591 48.633 17.131C48.633 14.303 46.3283 12 43.4982 12ZM43.4982 20.3681C41.7124 20.3681 40.2587 18.9155 40.2587 17.131C40.2587 15.3466 41.7124 13.8939 43.4982 13.8939C45.2839 13.8939 46.7376 15.3466 46.7376 17.131C46.7376 18.9155 45.2839 20.3681 43.4982 20.3681Z",
    fill: "url(#paint5_linear_845_998)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8618 12C63.0317 12 60.727 14.303 60.727 17.131C60.727 19.9591 63.0317 22.2621 65.8618 22.2621C68.6919 22.2621 70.9966 19.9591 70.9966 17.131C70.9966 14.303 68.6919 12 65.8618 12ZM65.8618 20.3681C64.0761 20.3681 62.6223 18.9155 62.6223 17.131C62.6223 15.3466 64.0761 13.8939 65.8618 13.8939C67.6475 13.8939 69.1012 15.3466 69.1012 17.131C69.1012 18.9155 67.6475 20.3681 65.8618 20.3681Z",
    fill: "url(#paint6_linear_845_998)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1348 12C18.3047 12 16 14.303 16 17.131C16 19.9591 18.3015 22.2621 21.1348 22.2621C23.9681 22.2621 26.2696 19.9591 26.2696 17.131C26.2696 14.303 23.9649 12 21.1348 12ZM21.1348 20.3681C19.3491 20.3681 17.8953 18.9155 17.8953 17.131C17.8953 15.3466 19.3491 13.8939 21.1348 13.8939C22.9205 13.8939 24.3743 15.3466 24.3743 17.131C24.3743 18.9155 22.9205 20.3681 21.1348 20.3681Z",
    fill: "url(#paint7_linear_845_998)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_845_998",
    x1: 11.5963,
    y1: 35.3512,
    x2: 75.199,
    y2: 35.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#FA4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866AFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_845_998",
    x1: 11.5961,
    y1: 17.1318,
    x2: 75.1987,
    y2: 17.1318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#FA4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866AFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_845_998",
    x1: 11.5961,
    y1: 17.1318,
    x2: 75.1988,
    y2: 17.1318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#FA4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866AFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_845_998",
    x1: 11.5963,
    y1: 17.1318,
    x2: 75.199,
    y2: 17.1318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#FA4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866AFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_845_998",
    x1: 11.5963,
    y1: 35.3512,
    x2: 75.199,
    y2: 35.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#FA4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866AFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_845_998",
    x1: 11.5961,
    y1: 17.1318,
    x2: 75.1987,
    y2: 17.1318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#FA4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866AFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_845_998",
    x1: 11.5961,
    y1: 17.1318,
    x2: 75.1988,
    y2: 17.1318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#FA4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866AFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_845_998",
    x1: 11.5963,
    y1: 17.1318,
    x2: 75.199,
    y2: 17.1318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#FA4770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866AFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCaracGrupo);
export default __webpack_public_path__ + "static/media/icono_carac_grupo.6f72415b2c7bbf7674216b44e1a43ab3.svg";
export { ForwardRef as ReactComponent };